<template>
    <div>
        <div class="form-floating">
            <input 
                v-model="fb.url"
                @blur="blurFB()"
                type="text" 
                class="form-control" 
                id="floatingMeno" 
                placeholder="Meno">
            <label for="floatingMeno">Facebook URL</label>
            <small v-if="fb.https != 0" class="https-check" :class="fb.https == 1 ? '' : 'checked'">HTTPS</small>
        </div>
        <div class="form-floating mt-3">
            <input 
                v-model="ig.url"
                @blur="blurIG()"
                type="text" 
                class="form-control" 
                id="floatingMeno" 
                placeholder="Meno">
            <label for="floatingMeno">Instagram URL</label>
           <small v-if="ig.https != 0" class="https-check" :class="ig.https == 1 ? '' : 'checked'">HTTPS</small>
        </div>
        <div class="form-floating mt-3">
            <input 
                v-model="yt.url"
                @blur="blurYT()"
                type="text" 
                class="form-control" 
                id="floatingMeno" 
                placeholder="Meno">
            <label for="floatingMeno">Youtube URL</label>
            <small v-if="yt.https != 0" class="https-check" :class="yt.https == 1 ? '' : 'checked'">HTTPS</small>
       </div>
        <div class="form-floating mt-3">
            <input 
                v-model="lin.url"
                @blur="blurLIN()"
                type="text" 
                class="form-control" 
                id="floatingMeno" 
                placeholder="Meno">
            <label for="floatingMeno">LinkedIn URL</label>
            <small v-if="lin.https != 0" class="https-check" :class="lin.https == 1 ? '' : 'checked'">HTTPS</small>
       </div>
    </div>
</template>

<script>
    export default {
        props: ['company'],
        data() {
            return {
                fb: {
                    https: 0,
                    url: ""
                },
                ig: {
                    https: 0,
                    url: ""
                },
                yt: {
                    https: 0,
                    url: ""
                },
                lin: {
                    https: 0,
                    url: ""
                }
            }
        },
        created () {
            this.fb.url = this.company ? this.company.fb : ""   
            this.ig.url = this.company ? this.company.ig : ""
            this.yt.url = this.company ? this.company.yt : ""
            this.lin.url = this.company ? this.company.lin : ""
        },
        methods: {
            sendData(){
                var data = {
                    "fb": this.fb.url,
                    "ig": this.ig.url,
                    "yt": this.yt.url,
                    "lin": this.lin.url,
                };
                this.$emit('data', data);
            },
            blurFB(){
                if(this.fb.url == "" || this.fb.url == null){
                }else{
                    var prefix_s = "https://"
                    var prefix = "http://"
                    if(this.fb.url.substring(0,prefix.length) == prefix){
                        this.fb.url = this.fb.url.slice(prefix.length);
                    }
                    if(this.fb.url.substring(0,prefix_s.length) != prefix_s){
                        this.fb.url = prefix_s + this.fb.url
                    }
                }
            },
            blurIG(){
                if(this.ig.url == "" || this.ig.url == null){
                }else{
                    var prefix_s = "https://"
                    var prefix = "http://"
                    if(this.ig.url.substring(0,prefix.length) == prefix){
                        this.ig.url = this.ig.url.slice(prefix.length);
                    }
                    if(this.ig.url.substring(0,prefix_s.length) != prefix_s){
                        this.ig.url = prefix_s + this.ig.url
                    }
                }
            },
            blurYT(){
                if(this.yt.url == "" || this.yt.url == null){
                }else{
                    var prefix_s = "https://"
                    var prefix = "http://"
                    if(this.yt.url.substring(0,prefix.length) == prefix){
                        this.yt.url = this.yt.url.slice(prefix.length);
                    }
                    if(this.yt.url.substring(0,prefix_s.length) != prefix_s){
                        this.yt.url = prefix_s + this.yt.url
                    }
                }
            },
            blurLIN(){
                if(this.lin.url == "" || this.lin.url == null){
                }else{
                    var prefix_s = "https://"
                    var prefix = "http://"
                    if(this.lin.url.substring(0,prefix.length) == prefix){
                        this.lin.url = this.lin.url.slice(prefix.length);
                    }
                    if(this.lin.url.substring(0,prefix_s.length) != prefix_s){
                        this.lin.url = prefix_s + this.lin.url
                    }
                }
            }
        },
        watch: {
            "fb.url": function() {
                if(this.fb.url == "" || this.fb.url == null)
                    this.fb.https = 0
                else{
                    if(this.fb.url.includes("https"))
                        this.fb.https = 2
                    else{
                        this.fb.https = 1
                    }
                }
                this.sendData()
            },
            "ig.url": function() {
                if(this.ig.url == "" || this.ig.url == null)
                    this.ig.https = 0
                else{
                    if(this.ig.url.includes("https"))
                        this.ig.https = 2
                    else
                        this.ig.https = 1
                }
                this.sendData()
            },
            "yt.url": function() {
                if(this.yt.url == "" || this.yt.url == null)
                    this.yt.https = 0
                else{
                    if(this.yt.url.includes("https"))
                        this.yt.https = 2
                    else
                        this.yt.https = 1
                }
                this.sendData()
            },
            "lin.url": function() {
                if(this.lin.url == "" || this.lin.url == null)
                    this.lin.https = 0
                else{
                    if(this.lin.url.includes("https"))
                        this.lin.https = 2
                    else
                        this.lin.https = 1
                }
                this.sendData()
            }
        },
    }
</script>


<style lang="scss" scoped>
.https-check{
    position: absolute;
    right: 5px;
    top: 2px;    
    font-size: 9px;
    color: #F3385A;
    &.checked{
        color: #23caa9;
    }
}

.textarea{
    border: 1px solid #DDE3E8;
    border-radius: 0;
    textarea{
        border: none !important;
        border-top: 25px solid transparent !important;
        padding-top: 0;
        width: 100%;
        height: 120px;
        background: #FFFFFF;
        box-sizing: border-box;
    }
}
.dateInput{
    display: grid;
}
.dateInput .mx-input{
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
}
.dateInput .mx-datepicker{
    width: 100% !important;
}
.dateInput path{
    fill: #383C4C !important;
}

.form-floating{
    margin-top: 20px;
}
h3{
   font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #212541;
}
p{
    margin-top: 7px;

    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #9598A7;
}
.form-floating > label{
    padding: 22px 13px;

    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9598A7;
}
input{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #212541;

    border: 1px solid #DDE3E8;
    border-radius: 0;
}
label{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
}
input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0px 10px 0 0px;
    background: #C7D4EB;
    border-radius: 25px;
}
.toggle{
    height: 22px;
    width: 40px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: none;
    background: #FFFFFF;
    border-radius: 3px;
    transition: all 0.2s ease;
    &:focus {
        outline: 0;
    }
    &:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }
    &:checked {
        border-color: #2ED8B6;
        background: #2ED8B6;
    }
    &:checked:after {
        transform: translatex(20px);
        
    }
}
.mobile_doba_inputs{
    display: grid !important;
}
.doba_inputs{
    background: white;
    padding: 20px;
    width: 100%;
    @media (max-width: 550px){
        margin: 20px 0 !important;
    }
    .form-floating > label, .float-container label{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598A7;
    }
    input{
        height: 50px;
        border-radius: 0
    }
    textarea{
        border-radius: 0
    }
}
.info{
    position: relative;
    height: 20px;
    margin-left: 10px;
    .info_icon{
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img{
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip{
        bottom: 22px;
        right: -7px;
    }
}
.agree_tooltip{
    position: relative;
}
.my_tooltip{
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #F3385A;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity .5s ease-in-out;
    &::after{
        content: '';
        width: 15px;
        height: 15px;
        background: #F3385A;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
</style>